import { Directive } from '@angular/core';

/**
 * `<aumico-logged-out-footer>`
 *
 */
@Directive({
    selector: 'aumico-logged-out-footer',
    host: {
        class: 'aumico-logged-out-footer',
    },
})
export class AumLoggedOutFooter {}
